
import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowRight, Users, MousePointerClick, Rocket } from 'lucide-react';
import { usePhemexLang } from '@/contexts/PhemexLangContext';
import { motion } from 'framer-motion';

const StepsSection = () => {
  const { t } = usePhemexLang();
  
  const stepVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: (i: number) => ({
      opacity: 1,
      y: 0,
      transition: {
        delay: i * 0.2,
        duration: 0.5
      }
    })
  };
  
  return (
    <div className="py-16 px-4 relative">
      <div className="max-w-5xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-2" style={{ color: '#38d102' }}>
          {t.steps.title}
        </h2>
        <p className="text-center text-gray-300 mb-12">
          {t.steps.subtitle}
        </p>
        
        <div className="grid md:grid-cols-3 gap-8 mb-10">
          <motion.div 
            className="flex flex-col items-center"
            custom={0}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={stepVariants}
          >
            <div className="bg-blue-600 w-16 h-16 rounded-lg flex items-center justify-center mb-4 relative">
              <div className="absolute -top-2 -right-2 bg-blue-600 rounded-full w-6 h-6 flex items-center justify-center text-white font-bold">
                1
              </div>
              <Users size={30} className="text-white" />
            </div>
            <h3 className="text-xl font-bold text-white text-center mb-2">
              {t.steps.step1.title}
            </h3>
            <p className="text-gray-300 text-center">{t.steps.step1.description}</p>
          </motion.div>
          
          <motion.div 
            className="flex flex-col items-center"
            custom={1}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={stepVariants}
          >
            <div className="bg-blue-600 w-16 h-16 rounded-lg flex items-center justify-center mb-4 relative">
              <div className="absolute -top-2 -right-2 bg-blue-600 rounded-full w-6 h-6 flex items-center justify-center text-white font-bold">
                2
              </div>
              <MousePointerClick size={30} className="text-white" />
            </div>
            <h3 className="text-xl font-bold text-white text-center mb-2">
              {t.steps.step2.title}
            </h3>
            <p className="text-gray-300 text-center">{t.steps.step2.description}</p>
          </motion.div>
          
          <motion.div 
            className="flex flex-col items-center"
            custom={2}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={stepVariants}
          >
            <div className="bg-blue-600 w-16 h-16 rounded-lg flex items-center justify-center mb-4 relative">
              <div className="absolute -top-2 -right-2 bg-blue-600 rounded-full w-6 h-6 flex items-center justify-center text-white font-bold">
                3
              </div>
              <Rocket size={30} className="text-white" />
            </div>
            <h3 className="text-xl font-bold text-white text-center mb-2">
              {t.steps.step3.title}
            </h3>
            <p className="text-gray-300 text-center">{t.steps.step3.description}</p>
          </motion.div>
        </div>
        
        <div className="flex justify-center mb-6">
          <Link to="/signup?campaign=phemex">
            <Button className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-6 text-lg rounded-full flex items-center gap-2">
              {t.hero.signUpForFree} <ArrowRight className="ml-1" size={20} />
            </Button>
          </Link>
        </div>
        
        <p className="text-center text-gray-400">
          {t.steps.joinText}
        </p>
      </div>
    </div>
  );
};

export default StepsSection;
